import React from 'react'
import { Redirect, Route } from 'react-router-dom'

interface IProps {
	path: string
	exact: boolean

	redirectTo: string
	children: React.ReactNode

	redirectIf: () => boolean
}

export const GuardedRoute = (
	props: IProps
): React.ReactElement => {
	if (props.redirectIf()) {
		return (
			<Route path={props.path} exact={props.exact}>
				<Redirect to={props.redirectTo}/>
			</Route>
		)
	}
	return (
		<Route path={props.path} exact={props.exact}>
			{props.children}
		</Route>
	)

}
